import React from 'react'
import {
  Switch,
  Route,
  BrowserRouter
} from 'react-router-dom'
import Invoice from './Components/Invoice/Invoice'

/**
 * Main app
 * @returns {void} .
 */
const App = () => (
  <BrowserRouter>
    <Switch>
      <Route
        path={['/:operationId', '/']}
        component={() => (
          <Invoice />
        )}
      />
    </Switch>
  </BrowserRouter>
)

export default App
